<template>
  <div class="widget card rounded-0">
    <header class="card-header d-flex justify-content-between">
      <h3 class="p-0 m-0 text-left d-flex align-items-center"> 
        <slot name="title">
        <img v-if="img" :src="img" />
        <i v-else-if="icon" :class="icon"></i> 
        
        <span class="pl-3">
          <a v-if="collapsable" href="#" data-toggle="collapse" :data-target="'#' + collapseId">{{ title }}</a>
          <span v-else>{{ title }}</span>
          <template v-if="subtitle">
            <br/>
            <small class="">{{subtitle}}</small>
          </template>
        </span>
        </slot>
      </h3>

      <div class="btn-toolbar align-items-center" :class="{ 'p-0' : edge }" role="toolbar" aria-label="Toolbar with button groups">
        <div class="btn-group btn-group-sm mr-1" :class="{disabled: disable}" role="group" aria-label="Second group">
          <slot name="toolbar-button"></slot>
        </div>
        <div v-if="collapsable" class="btn-group btn-group-sm" role="group">
          <button type="button" class="btn btn-link chevron" :class="{collapsed : collapse}" data-toggle="collapse" :data-target="'#' + collapseId"><i class="fas fa-chevron-down"></i></button>
        </div>
      </div>
    </header>

    <div ref="collapse" class="collapse" :class="{ show: !collapse }" :id="collapseId">
    <div class="card-body" :class="{ 'p-0' : edge }">
      <slot></slot>
    </div>
    </div>
    
    <footer v-if="$slots.footer" class="card-footer text-muted border-0 p-0">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    error: String,
    collapse: Boolean,
    collapsable: Boolean,
    title: String,
    subtitle: String,
    icon: String,
    img: String,
    edge: Boolean,
    disable: Boolean
  },

  computed: {
    collapseId() {
      return this.name + '-collapse';
    }
  },

  mounted() {
    
  }
};
</script>

<style scoped lang="scss" type="text/scss">
  h3 {
    font-size: 1em;

    small {
      font-size:.8em;
    }
  }

  .card-header {
    background-color: inherit;

    a {
      color: inherit;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .btn-link:hover {
    color:inherit;
  }

  .chevron .fas {
  transition: .3s transform ease-in-out;
  }
  .chevron.collapsed .fas {
    transform: rotate(-90deg);
  }
</style>




// WEBPACK FOOTER //
// src/lib/ui/Widget.vue